// ========================================
// FILE 2: ContactPage.jsx (Main Page)
// ========================================

import React from 'react';
import ContactSection from './ContactSection';

const ContactPage = () => {
  return (
    <div style={{ paddingTop: '60px' }}>
      <ContactSection />
    </div>
  );
};


export default ContactPage;